import WebAuthnProvider from './WebAuthnProvider';

/**
 * Windows Hello Specialized Platform Provider.
 * Extends WebAuthnProvider with Windows Hello biometric and PIN detection.
 */
export class WindowsHelloProvider extends WebAuthnProvider {
  constructor() {
    super();
    this.name = 'Windows Hello Platform Authenticator';
  }

  async isAvailable() {
    const baseAvailable = await super.isAvailable();
    if (!baseAvailable) return false;

    // Checks specifically for user-verifying platform authenticator
    return await this.isPlatformAuthenticatorAvailable();
  }

  async getDeviceInfo() {
    const isWindows = navigator.userAgent.includes('Windows');
    const available = await this.isAvailable();

    return {
      providerName: isWindows ? 'Windows Hello Biometric / PIN' : 'Platform Biometrics',
      deviceType: 'PlatformAuthenticator',
      supportsBiometrics: true,
      isAvailable: available,
    };
  }
}

export default WindowsHelloProvider;
